import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { Check, X } from 'lucide-react';
export function WhoIsItFor() {
  const {
    ref,
    isVisible
  } = useScrollAnimation();
  const forWho = ["Madres mayores de 35 años que sienten que 'ya no pueden más'.", 'Mujeres que manejan casa y carrera y sienten que están fallando en ambas.', 'Aquellas que sufren de irritabilidad constante y culpa materna.', 'Mujeres que se sienten desconectadas de sí mismas por el agotamiento crónico.'];
  const notForWho = ['Personas que buscan una solución mágica sin cambiar ni un micro-hábito.', 'Quienes esperan un libro teórico de 300 páginas (esto es una guía de acción inmediata).', 'Personas que no están dispuestas a poner límites básicos por 72 horas.'];
  return <section className="py-20 px-4 bg-white" data-id="element-147">
      <div ref={ref} className={`max-w-5xl mx-auto transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-148">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-149">
          {/* Para quién es */}
          <div className="bg-sage/20 p-8 md:p-10 rounded-3xl border border-sage" data-id="element-150">
            <h3 className="text-2xl font-serif text-teal mb-8 flex items-center gap-3" data-id="element-151">
              <span className="bg-teal text-white w-8 h-8 rounded-full flex items-center justify-center text-sm" data-id="element-152">
                ✓
              </span>
              Esto ES para ti si...
            </h3>
            <ul className="space-y-6" data-id="element-153">
              {forWho.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-154">
                  <Check className="w-6 h-6 text-teal shrink-0 mt-0.5" data-id="element-155" />
                  <span className="text-charcoal" data-id="element-156">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Para quién NO es */}
          <div className="bg-gray-50 p-8 md:p-10 rounded-3xl border border-gray-100" data-id="element-157">
            <h3 className="text-2xl font-serif text-charcoal/60 mb-8 flex items-center gap-3" data-id="element-158">
              <span className="bg-gray-200 text-gray-500 w-8 h-8 rounded-full flex items-center justify-center text-sm" data-id="element-159">
                ✕
              </span>
              Esto NO es para ti si...
            </h3>
            <ul className="space-y-6" data-id="element-160">
              {notForWho.map((item, i) => <li key={i} className="flex items-start gap-4 opacity-70" data-id="element-161">
                  <X className="w-6 h-6 text-gray-400 shrink-0 mt-0.5" data-id="element-162" />
                  <span className="text-charcoal" data-id="element-163">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}